import React from 'react';
import { useSelector } from 'react-redux';

import { isManualChoice } from '~utils/flowChoice';

import ClientIncomes from '../ClientIncomes';
import ClientUniqueKeyLogin from '../ClientUniqueKeyLogin';

function ClientFinancialInformation() {
  const { clientFlowChoice, clientUniqueKeySubmitted } = useSelector(state => state.simulation);
  // With ClaveÚnica the client first logs in natively and then, like in the manual
  // flow, uploads the certificates (still required in this first iteration).
  const showLogin = !isManualChoice(clientFlowChoice) && !clientUniqueKeySubmitted;
  return showLogin ? <ClientUniqueKeyLogin /> : <ClientIncomes />;
}

export default ClientFinancialInformation;
